import { PostHogProvider } from '@posthog/react';
import * as Sentry from '@sentry/react';
import { AuthKitProvider } from '@workos-inc/authkit-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { Toaster } from './components/ui/sonner';

export interface BootstrapOptions {
  workosClientId: string;
  posthogApiKey: string;
  posthogOptions: {
    readonly api_host: string | undefined;
    readonly defaults: '2026-01-30';
  };
  isLocalhost: boolean;
}

export async function loadI18nResources(): Promise<void> {
  await import('./lib/i18n');
}

export async function bootstrapApp(root: HTMLElement, options: BootstrapOptions): Promise<void> {
  await loadI18nResources();

  createRoot(root).render(
    <StrictMode>
      <PostHogProvider apiKey={options.posthogApiKey} options={options.posthogOptions}>
        <AuthKitProvider clientId={options.workosClientId} devMode={options.isLocalhost}>
          <App />
          <Toaster />
        </AuthKitProvider>
      </PostHogProvider>
    </StrictMode>,
  );
}

export function renderBootstrapFailure(root: HTMLElement, error: unknown): void {
  Sentry.captureException(error);
  console.error('[bootstrap] Failed to load application', error);

  createRoot(root).render(
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-foreground">Algo deu errado.</h1>
        <p className="mt-2 text-muted-foreground">
          Não foi possível carregar a aplicação. Tente recarregar a página.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 rounded-md bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
        >
          Recarregar página
        </button>
      </div>
    </div>,
  );
}
